import type { RemoteCommandLogEntry } from '../../hooks/usePresentationRemoteController';

export const REMOTE_ERROR_LABEL: Record<string, string> = {
  timeout: '응답 없음',
  no_target: '대상 없음',
  autoplay_blocked: '자동재생 차단 — 프레젠 화면을 한 번 터치해 주세요',
  not_implemented: '지원하지 않는 명령 — 프레젠테이션 탭을 새로고침해 주세요',
  tts_blocked: '읽어주기 차단 — 프레젠 화면을 한 번 터치하면 읽어요 (내용은 표시됨)',
  tts_unavailable: '이 기기에서 읽어주기를 지원하지 않음 (내용은 표시됨)',
  nothing_to_speak: '표시 중인 내용 없음',
  invalid_payload: '내용 오류',
  unknown: '오류',
};

export function remoteEntryStatusText(e: Pick<RemoteCommandLogEntry, 'state' | 'error'>): string {
  if (e.state === 'pending') return '전송 중…';
  if (e.state === 'ok') return '완료';
  return `실패${e.error ? ` · ${REMOTE_ERROR_LABEL[e.error] ?? e.error}` : ''}`;
}

export function hhmm(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
